class Basket {
	constructor(){
		this.summ = 0;
		this.count = 0;
	}

  showItems(container, arrayProd){
    let itemHtml = [ arrayProd ].map(({ link, image, product, price }, index) => {
      let [, integer, decimal] = price.match(/^(\d+\.?\-?)(\d*)/);
      let int = integer.replace('.', '');
      let wid = link.split('?wid=')[1];
      return `<div class="row text-center border-top p-2" data-model="${product}"><div class="col-4 col-sm-2 col-md-2 col-lg-2">
        <img class="img-thumbnail rounded" src="${image}" alt="${product} - ${price} - [${index}]" onerror="this.src='uploads/onsearch.jpg';"/>
      </div>
      <div class="col-8 col-sm-4 col-md-2 col-lg-2"><p class="item-text m-1">${product}</p></div>
      <div class="col-4 col-sm-2 col-md-3 col-lg-3">
        <p class="item-text m-1">1</p>
      </div>
      <div class="col-4 col-sm-2 col-md-2 col-lg-2">
        <!--p class="item-wid m-2">Wid: <small>${wid}</small></p-->
        <p class="m-2">$<span class="price item-price">${int}${decimal ? "" : "-"}<span class="cents">${
            decimal ? (decimal + "0").slice(0, 2) : ""
          }</span></span></p>
      </div>
      <div class="col-4 col-sm-2 col-md-3 col-lg-3">
        <button type="button" class="btn btn-sm m-1">
          <span class="ico ico-color_blue ico-66 buy-remLS item-buy" title="${product}" data-price="${price}"></span>
        </button>
        </div>
      </div>`;
    }).join("");

    //document.getElementById(container).innerHTML += itemHtml;
    container.innerHTML += itemHtml;
  }

  showTotal(){

  }

  blendBtn(arr, target){
  	let cl = parseInt(target.dataset.blend, 10);
  	let phrase = (arr[cl]).split(" ");
  	let nw = [];
  	cl += 1;
  	target.dataset.blend = cl;
  	target.innerHTML = "";
  	phrase.forEach( wd => {
  		nw.push( wd.split("").map( s => `<span>${s}</span>`).join("") );
  	});

  	let ww = nw.join(" ");
  	target.innerHTML = ww;
  	target.classList.remove('go');
  	if( cl > arr['length']-1 ){
  		target.dataset.blend = 0;
  	}
  	setTimeout( () => {
  		target.classList.add('go');
  	}, 250);
  }
}

window.onload = function(){

  (async function() {
  	const products = await fetch("json/data.json").then(response =>
  		response.json()
  	)

		let lsBasket = new LocStore();
		let lsResultBasket = lsBasket.getLS('itemBuy');

		let showBasket = new Basket(lsResultBasket);
		productsBasket.innerHTML = '';

		if( lsResultBasket === undefined ) {
			return;
		} else {
			let sortArr = [];
			products.forEach( (el, idx) => {
				lsResultBasket.forEach( (s) => {
					if(el['product'] === s ) {
						if( !sortArr.includes(s) ){ 
							showBasket.showItems(productsBasket, el);
							sortArr.push(s);
							showBasket.summ += parseFloat(el['price']);
						}
					}
				});
			});
			summic.textContent = (showBasket.summ).toFixed(2);
			countic.textContent = lsResultBasket['length'];
		}

		document.addEventListener('click', function(e){
			let target = e.target;
			if(target.classList.contains('buy-remLS')){
				let title = target.getAttribute('title');
				//console.log('buy title: ', title );
				let curPrice = parseFloat( target.dataset.price );
				lsBasket.remLS('itemBuy', title);
				target.closest('.row').remove();
				showBasket.summ -= curPrice;
				//console.log(showBasket.summ);
			  summic.textContent = (showBasket.summ).toFixed(2);
			  countic.textContent = (countic.textContent - 1);
			}
			if( target.classList.contains('basket-clean') ){
				lsBasket.delLS('itemBuy');
				productsBasket.innerHTML = '';
				summic.textContent = 0;
				countic.textContent = 0;
				console.log('X: ', (showBasket.summ).toFixed(2));
			}
			if( target.id === "blend" ){
				let arr = ["process order","lucky you","Awesome!"];
				showBasket.blendBtn(arr, target);
			}
		}, false);

  })();

};